import { Component, OnInit, HostListener, ViewChild  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PROFILE_NAV  } from '../../constants/navigation';
import {MatTreeModule} from '@angular/material/tree';
import { AuthService, CorporateService, HttpService, LoaderService, UtilityService } from '../../services';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSidenav } from '@angular/material/sidenav';
import { AuthSystemComponent } from '../auth-system/auth-system.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {
  isLoggedIn = false;
  SideNavItems = PROFILE_NAV;
  currency = JSON.parse(localStorage.getItem('currency_List')!);
  selectedItem: any = "";
  currencySelected: any = "";
  @ViewChild('sidenav') sidenav: MatSidenav;
  balance = 0;
  
  constructor(private router: Router, private route: ActivatedRoute, public util: UtilityService, public http: HttpService, private authService: AuthService,
    private snackbar: MatSnackBar,  public dialog: MatDialog, public COPT: CorporateService) {
      // this.getProfileImage();
      if (this.authService.loggedIn()) {
        this.isLoggedIn = true;
      } else {
      // this.isLoggedIn = false;
    }

    // if(this.currencySelected !== '') {
    //   this.currencySelected = JSON.parse(localStorage.getItem('currency_List_Selected')!)
    // } else if (this.currencySelected === '') {
    //   this.currencySelected = this.currency[0];
    // }
  }
  ngOnInit(): void {
  }
  
  
  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const clickedInsideSidenav = target.closest('.sidenav');
    const clickedMenuIcon = target.closest('.menuIcon');

    if (!clickedInsideSidenav && !clickedMenuIcon && this.sidenav.opened) {
      this.sidenav.close();
    }
  }

  login() {
    // this.router.navigate(['signIn'], { relativeTo: this.route })
    this.dialog.open(AuthSystemComponent, {
      panelClass: 'customAuthDialog'
    })
  }

  logOut() {
    this.util.logOutUser();
  }
  select(newValue) {
    this.selectedItem = newValue;
    this.selectedItem = localStorage.setItem('currency_List_Selected' , JSON.stringify(newValue));
    this.currencySelected = JSON.parse(localStorage.getItem('currency_List_Selected')!);
  }
  
  profile_image() {
    return JSON.parse(localStorage.getItem('Flight_User_Detiles') || 'null')?.profile_img || null;
  }
}
